import React, { useState } from 'react';
import Alert from 'react-bootstrap/Alert';

function ClosedIssueNotification() {
  const [show, setShow] = useState(true);

  return (
      <Alert show={show} variant="danger" onClose={() => setShow(false)} dismissible>
          <Alert.Heading>
              This issue/request has been closed.
          </Alert.Heading>
          <p>
            You may still review this at any time in the future.
          </p>
      </Alert>
  );
}

export default ClosedIssueNotification;
